import { render } from "./TelefonosContent.vue?vue&type=template&id=39838270"
import script from "./TelefonosContent.vue?vue&type=script&lang=js"
export * from "./TelefonosContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__